import styled from "@emotion/styled";

interface Props {
  maxWidth?: number;
}

const Container = styled.div<Props>`
  width: 100%;
  max-width: ${props => (props.maxWidth ? props.maxWidth : "1140px")};
  margin: 0 auto;
  box-sizing: border-box;
`;

export default Container;
